module.exports = __webpack_public_path__ + "static/media/calenderIc.a5a86f0c.svg";